import { View } from 'react-native'
import Text from 'theme/Text'
import React from 'react'
import { TextDividerStyles } from 'styles/components/atoms/TextDivider'
import isEqual from 'react-fast-compare'

const TextDivider = ({text = '', rowStyle = null, testID = null}) => {
	
	return (
		<View
			style={ [ TextDividerStyles.row, rowStyle ] }
			testID={testID}>
			
			<Text style={ TextDividerStyles.text }>{text}</Text>
			<View style={ TextDividerStyles.line } />
		</View>
	);
};

export default React.memo( TextDivider, isEqual );

